import { Genre } from './types';

/**
 * RiffWriter modules are flavor/scene names ("Capricorn Swamp Forge", "Riff
 * Graveyard"). They're useful inside the app but they aren't real genres
 * anyone outside HookHouse would recognize. Anywhere we hand a seed off to
 * downstream features that need a real-world genre label (Studio Team's 11
 * agents, Suno tags, prompts, etc.), map through this table first.
 */
const FAMILY: Record<Genre, string> = {
  [Genre.FLYTE_TIME]: 'Minneapolis Funk / R&B',
  [Genre.CAPRICORN]: "'70s Southern Rock",
  [Genre.MUSCLE_SHOALS]: 'Southern Soul / R&B',
  [Genre.STAX]: 'Memphis Soul / R&B',
  [Genre.BAKERSFIELD]: 'Bakersfield Country',
  [Genre.NASHVILLE]: 'Country Pop',
  [Genre.PHILLY]: 'Philly Soul / R&B',
  [Genre.MOTOWN]: 'Motown Soul',
  [Genre.AMERICANA]: 'Americana',
  [Genre.COUNTRY_SALOON]: 'Honky-Tonk Country',
  [Genre.DOOM_METAL]: 'Doom Metal',
  [Genre.SOUTHERN_ROCK_PORCH]: 'Acoustic Southern Rock',
  [Genre.SOUTHERN_METAL]: 'Southern Groove Metal',
  [Genre.WEST_COAST_HIP_HOP]: 'West Coast Hip-Hop',
  [Genre.CHORAL_SLUDGE]: 'Sludge / Doom Metal',
  [Genre.RIFF_GRAVEYARD]: 'Stoner / Heavy Riff Rock',
  [Genre.ALBUM_ORIENTED_ROCK]: "'70s AOR / Classic Rock",
  [Genre.CLASSICAL]: 'Classical',
};

/** Get the real-world genre label for a RiffWriter module slug. */
export function getGenreFamily(slug: string): string {
  return FAMILY[slug as Genre] ?? slug.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
